document.addEventListener("DOMContentLoaded", function () {
document.getElementById("closePopup").addEventListener("click", function () {
  document.getElementById("cancelPopup").style.display = "none";
});

    function initCancelOverride() {
        const subscriptionWrapper = document.querySelector('[data-recharge-subscription]');
        if (!subscriptionWrapper) {
            return setTimeout(initCancelOverride, 300);
        }

        const subscriptionId = subscriptionWrapper.getAttribute("data-recharge-subscription");
        if (subscriptionId === "6629793824870") {

        const cancelBtn = document.querySelector('[data-recharge-subscription-cancel="true"] span[role="button"]');
        if (!cancelBtn) {
            return setTimeout(initCancelOverride, 300);
        }
        const freshBtn = cancelBtn.cloneNode(true);
        cancelBtn.parentNode.replaceChild(freshBtn, cancelBtn);

           function customClickHandler(e) {
            e && e.preventDefault();
            e && e.stopImmediatePropagation();

            if (subscriptionId === "6629793824870") {
                  document.getElementById("cancelPopup").style.display = "flex";
            } else {
                console.log("Different subscription → Allow normal cancel");
            }
        }
        freshBtn.addEventListener("click", customClickHandler);
          
    }
    }

    initCancelOverride();
});

